import { CalEventFieldType } from '../constants/cal-event-field-type.js';
export function isPerProductFieldType(typeId) {
    return typeId === CalEventFieldType.PER_PRODUCT_NUMBER;
}
//# sourceMappingURL=is-per-product-field-type.js.map